import { Component, Input } from "@angular/core";
import { RouteCurrent } from "../dispatching-invoicing.component";
import { NgIf } from "@angular/common";
import { TranslatePipe } from "@ngx-translate/core";

@Component({
    "selector": "load-info-display",
    "templateUrl": "./load-info-display.component.html",
    "styleUrls": ["./load-info-display.component.scss"],
    imports: [NgIf, TranslatePipe]
})
export class LoadInfoDisplayComponent{
  @Input() routeCurrent : RouteCurrent;
  @Input() showUser : boolean = true;
}
